import { render, staticRenderFns } from "./OrgIntro.vue?vue&type=template&id=46c9bca0&scoped=true"
import script from "./OrgIntro.vue?vue&type=script&lang=js"
export * from "./OrgIntro.vue?vue&type=script&lang=js"
import style0 from "./OrgIntro.vue?vue&type=style&index=0&id=46c9bca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c9bca0",
  null
  
)

export default component.exports